module.exports = __webpack_public_path__ + "img/HarruPotter.aae04911.jpg";